import React from 'react';
import ListItem from '@mui/material/ListItem';
import withStyles from '@mui/styles/withStyles';

const ListItemCM = props => {
    const { selected } = props;
    return <ListItem className={`task-bucket-list-item${selected ? ' selected' : ''}`} {...props} />;
};

export default withStyles({})(ListItemCM);
